"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskProgressBeanObjectToJSON = exports.TaskProgressBeanObjectFromJSONTyped = exports.TaskProgressBeanObjectFromJSON = exports.instanceOfTaskProgressBeanObject = exports.TaskProgressBeanObjectStatusEnum = void 0;
/**
 * @export
 */
exports.TaskProgressBeanObjectStatusEnum = {
    Enqueued: 'ENQUEUED',
    Running: 'RUNNING',
    Complete: 'COMPLETE',
    Failed: 'FAILED',
    CancelRequested: 'CANCEL_REQUESTED',
    Cancelled: 'CANCELLED',
    Dead: 'DEAD'
};
/**
 * Check if a given object implements the TaskProgressBeanObject interface.
 */
function instanceOfTaskProgressBeanObject(value) {
    if (!('elapsedRuntime' in value))
        return false;
    if (!('id' in value))
        return false;
    if (!('lastUpdate' in value))
        return false;
    if (!('progress' in value))
        return false;
    if (!('self' in value))
        return false;
    if (!('status' in value))
        return false;
    if (!('submitted' in value))
        return false;
    if (!('submittedBy' in value))
        return false;
    return true;
}
exports.instanceOfTaskProgressBeanObject = instanceOfTaskProgressBeanObject;
function TaskProgressBeanObjectFromJSON(json) {
    return TaskProgressBeanObjectFromJSONTyped(json, false);
}
exports.TaskProgressBeanObjectFromJSON = TaskProgressBeanObjectFromJSON;
function TaskProgressBeanObjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'] == null ? undefined : json['description'],
        'elapsedRuntime': json['elapsedRuntime'],
        'finished': json['finished'] == null ? undefined : json['finished'],
        'id': json['id'],
        'lastUpdate': json['lastUpdate'],
        'message': json['message'] == null ? undefined : json['message'],
        'progress': json['progress'],
        'result': json['result'] == null ? undefined : json['result'],
        'self': json['self'],
        'started': json['started'] == null ? undefined : json['started'],
        'status': json['status'],
        'submitted': json['submitted'],
        'submittedBy': json['submittedBy'],
    };
}
exports.TaskProgressBeanObjectFromJSONTyped = TaskProgressBeanObjectFromJSONTyped;
function TaskProgressBeanObjectToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
        'elapsedRuntime': value['elapsedRuntime'],
        'finished': value['finished'],
        'id': value['id'],
        'lastUpdate': value['lastUpdate'],
        'message': value['message'],
        'progress': value['progress'],
        'result': value['result'],
        'self': value['self'],
        'started': value['started'],
        'status': value['status'],
        'submitted': value['submitted'],
        'submittedBy': value['submittedBy'],
    };
}
exports.TaskProgressBeanObjectToJSON = TaskProgressBeanObjectToJSON;
//# sourceMappingURL=TaskProgressBeanObject.js.map